import React, { Component } from 'react';
import { Button, Form, Icon, Loader, Table, Popup } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';


class RegisteredExamsByTerm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            term: null,
            year: 1,
            termOptions: [],
            exams: [],
            loading: true,
            academicYears: [],
            academicYear: null
        };
        this.getExamsByTerm = this.getExamsByTerm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.cancelExam = this.cancelExam.bind(this);
    }

    componentDidMount() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                const academicYears = res.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    academicYears,
                });
            });

        if (this.state.term) {
            this.getExamsByTerm(this.state.term);
        } else {
            this.setState({ loading: false });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'academicYear') {
            axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support')
                ? `/exams/terms-for-academic-year/${value}/${localStorage.getItem('orgUnit')}`
                : `/exams/terms-for-academic-year/${value}`)
                .then((res) => {
                    this.setState({
                        termOptions: res.data.map((el) => (
                            {
                                key: el.id,
                                value: el.id,
                                text: el.name
                            }
                        ))
                    });
                });
        } else {
            this.getExamsByTerm(value);
        }
    }


    cancelExam(studentId, studentGradedActivityId) {
        axios.put(`/student-exams/cancellation-for-admin/${studentId}/${studentGradedActivityId}`)
            .then(res => {
                toast(<FormattedMessage id="student.canceled" />);
                this.getExamsByTerm(this.state.term);
            }).catch(err => {
                toast(<FormattedMessage id="common.error" />);
            });
    }


    getExamsByTerm(term) {
        this.setState({ loading: true });
        axios.get(`/student-exams/${this.props.studentStudyProgramId}/${term}/`)
            .then(res => {
                const exams = res.data;
                this.setState({ exams, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false, });
                toast('Došlo je do greške. Nije moguće dostaviti podatke o ispitima.');
                console.log('Failed to fetch exams.', err);
            });
    }


    render() {
        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                placeholder="Odaberite akademsku godinu"
                                search
                                fluid
                                selection
                                options={this.state.academicYears}
                                onChange={this.handleInputChange}
                                value={this.state.academicYear}
                                name="academicYear"

                            />
                        </Form.Field>
                        <Form.Field disabled={!this.state.academicYear}>
                            <label>Ispitni rok</label>
                            <Form.Dropdown
                                placeholder="Odaberite ispitni rok"
                                search
                                fluid
                                selection
                                options={this.state.termOptions}
                                onChange={this.handleInputChange}
                                value={this.state.term}
                                name="term"

                            />
                        </Form.Field>
                    </Form.Group>
                </Form>
                {this.state.loading ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.exams.length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={2}>Predmet</Table.HeaderCell>
                                <Table.HeaderCell>Datum ispita</Table.HeaderCell>
                                <Table.HeaderCell>Tip ispita</Table.HeaderCell>
                                <Table.HeaderCell>Vrijeme prijave ispita</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>

                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {this.state.exams.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle" colSpan={2}>{el.gradedActivity.courseImplementation.courseBasic.name}</Table.Cell>
                                <Table.Cell verticalAlign="middle">{moment(el.gradedActivity.date).format('D. M. YYYY.')}</Table.Cell>
                                <Table.Cell verticalAlign="middle">{el.gradedActivity.type.name}</Table.Cell>
                                <Table.Cell verticalAlign="middle"> {el.applicationDate ? moment(el.applicationDate).format('D. M. YYYY. - HH:mm') : ''} </Table.Cell>
                                <Table.Cell verticalAlign="middle" positive={!el.canceled} negative={el.canceled}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            {!el.canceled ? 'prijavljen' : 'odjavljen'}
                                            {!el.canceled ? (
                                                <Icon name="checkmark" style={{ marginLeft: '8px' }} />
                                            ) : (
                                                <Icon name="close" style={{ marginLeft: '8px' }} />
                                            )}
                                        </div>

                                        {!el.canceled && moment(el.gradedActivity.date).isAfter(moment()) && (
                                            <Popup
                                                content="Odjavi ispit"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic
                                                        circular
                                                        icon
                                                        color="red"
                                                        size="mini"
                                                        onClick={() => this.cancelExam(JSON.parse(localStorage.getItem('student')).studentId, el.id)}
                                                    >
                                                        <Icon name="sign-out" />
                                                    </Button>
                                                }
                                            />
                                        )}
                                    </div>
                                </Table.Cell>


                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                        : this.state.term ? <div style={{ paddingTop: '10px', marginTop: '10px' }}> Student nema prijavljenih/odjavljenih ispita na odabranom ispitnom roku.</div> : ''}
            </div>
        );
    }
}

export default RegisteredExamsByTerm;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/RegisteredExamsByTerm.js